<template>
  <div class="loader" @change="change">
    <div class="browse">
      <input class="sr-only" id="file" type="file" accept="image/*" />
    </div>

    <!-- TODO: 
    step2: if props charges is invalid then render text doble click to Edit Image left via Event
    step3: when metod Ready is Exec catch de Modified Image and emmmit via events to Modal Index and refres tabs
    -->
  </div>
</template>

<script>
const URL = window.URL || window.webkitURL;
export default {
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    read(files) {
      return new Promise((resolve, reject) => {
        if (!files || files.length === 0) {
          //failed read file from Explorer
          resolve(); // return sucess
          return;
        }
        const file = files[0];
        /*/^image\/\w+/ is a regex that matches "image/png" and "image/jpeg" and all other strings that begin with "image/".
            /^image\/\w+/.test(s) tests if the given string s matches the regex.
            if (/^image\/\w+/.test(file.type)) checks if the file.type matches an image file type */
        if (/^image\/\w+$/.test(file.type)) {
          // is Image valid?
          if (URL) {
            //Is URL valid?
            resolve({
              //Return sucess with new Object
              loaded: true,
              name: file.name,
              type: file.type,
              url: URL.createObjectURL(file), //create URL to show in Editor
            });
          } else {
            reject(new Error("Your browser is not supported."));
          }
        } else {
          reject(new Error("Please choose an image file."));
        }
      });
    },
    change({ target }) {
      this.read(target.files)
        .then((data) => {
          target.value = "";
          this.update(data); //update Data with new DataFile
        })
        .catch((e) => {
          //Error
          target.value = "";
          this.alert(e);
        });
    },
    alert(e) {
      window.alert(e && e.message ? e.message : e);
    },
    update(data) {
      Object.assign(this.data, data);
    },
  },
};
</script>

<style  lang="scss" scoped>
.loader {
  display: table;
  height: 100%;
  overflow: hidden;
  width: 100%;
  & > p {
    color: #999;
    display: table-cell;
    text-align: center;
    vertical-align: middle;
  }
}
.browse {
  color: #0074d9;
  cursor: pointer;
  margin-left: 0.25rem;
  &:hover {
    color: #08f;
    text-decoration: underline;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Outputs/Images/PhotoEditor/components/loader.vue